export default "__VITE_ASSET__DZT99dwG__"